import { render, staticRenderFns } from "./SuccessIdAndPassword.vue?vue&type=template&id=1749e461&scoped=true"
import script from "./SuccessIdAndPassword.vue?vue&type=script&lang=js"
export * from "./SuccessIdAndPassword.vue?vue&type=script&lang=js"
import style0 from "./SuccessIdAndPassword.vue?vue&type=style&index=0&id=1749e461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749e461",
  null
  
)

export default component.exports